export const COLORS = {
	PRIMARY_LIGHT: "primaryLight"
}
